// V1-INTERACTIONS §4.4 — the request screens moved to the Mission Control design in lane B2 S08
// (src/views/request/: RequestsList, HiringRequest). What stays here is the V1 brand words the V1 requisition and archive
// screens still read; it leaves with those screens.

export const BRAND_LABEL: Record<string, string> = { auntie_annes: "Auntie Anne's", carvel: "Carvel", cinnabon: "Cinnabon", jamba: "Jamba", mcalisters: "McAlister's Deli", moes: "Moe's Southwest Grill", schlotzskys: "Schlotzsky's", corporate: "Not brand-specific / Corporate" };
